import { apiRequest } from '@/utils/request'

export function getAtbdcqzm(queryParams) {
  return apiRequest({
    url: '/Atbdcqzm',
    method: 'get',
    params: queryParams
  })
}

export function getAtbdcqzmList(queryParams) {
  return apiRequest({
    url: '/Atbdcqzm/GetList',
    method: 'get',
    params: queryParams
  })
}